import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import RangeByRegionByFacilityTypeStep from "../../../../../../../shared/wizard/steps/rangeByRegionByFacilityTypeStep";

interface ISelectionByOwnBuyStep_4 {
  typeIds: number[] | null;
  selectedPolygonIds: number[] | null;
}

const SelectionByOwnBuyStep_4 = ({
  typeIds,
  selectedPolygonIds,
}: ISelectionByOwnBuyStep_4) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_3);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_7);
  };

  const handleRepeatStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_5);
  };

  return (
    <div>
      <RangeByRegionByFacilityTypeStep
        selectedPolygonIds={selectedPolygonIds ?? []}
        typeIds={typeIds ?? []}
        onNextStep={handleNextStep}
        onRepeatStep={typeIds?.length === 1 ? handleRepeatStep : undefined}
        onPrevStep={handlePrevStep}
      />
    </div>
  );
};
export default SelectionByOwnBuyStep_4;
